import { TFunction } from 'react-i18next'
import { Constants } from '../../../../utils/constants'
import dayjs from 'dayjs'
import { actionPlansServices } from '../../../../service/actionPlans'
import { httpFetch } from '../../../../utils/crud'

const getAll = async (t: TFunction<'translation', undefined>, body?: { queries?: string; reloadData?: boolean }) => {
  const data = await actionPlansServices(httpFetch).getAutomaticTempDashboard(body?.queries)

  if (data.errors) {
    return {
      row: [],
      totalPages: 0,
      totalItems: 0,
      currentPage: 1,
    }
  }

  const row = data.items.map((item) => {
    const timeZone = Constants.defaultTimeZone
    const formatStart = item.dateInitAnswer
      ? dayjs(item.dateInitAnswer).tz(timeZone).locale('es').format(Constants.dayjsFormat4)
      : t('general.noData')
    const formatEnd = item.dateFinishAnswer
      ? dayjs(item.dateFinishAnswer).tz(timeZone).locale('es').format(Constants.dayjsFormat4)
      : t('general.noData')

    return {
      id: item.id,
      divisions: item.divisionName,
      stores: item.storeName,
      attentionType: item.byStoreSchedule === 1 ? t('actionPlan.byStores') : t('actionPlan.byUsers'),
      questionnaire: item.questionnaireName,
      answersCount: item.totalItems,
      userCreator: item.userFullName,
      startDate: {
        label: formatStart,
        value: item.dateInitAnswer ? new Date(item.dateInitAnswer).getTime() : 0,
        type: 'date',
      },
      endDate: {
        label: formatEnd,
        value: item.dateFinishAnswer ? new Date(item.dateFinishAnswer).getTime() : 0,
        type: 'date',
      },
    }
  })

  return {
    row,
    totalPages: data.totalPages,
    totalItems: data.totalItems,
    currentPage: data.currentPage,
  }
}

export { getAll }
